import { Link } from 'react-router-dom';
import { DocumentMagnifyingGlassIcon } from '@heroicons/react/24/outline';
import { usePageTitle } from '../hooks/usePageTitle';

const linkBase =
  'inline-flex items-center justify-center min-h-[44px] px-6 py-3 rounded-md font-medium transition-colors duration-150 focus-ring';

export default function NotFound() {
  usePageTitle('Page not found');

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
      <div className="text-center">
        <DocumentMagnifyingGlassIcon className="h-12 w-12 text-gray-400 mx-auto mb-4" />
        <h1 className="text-2xl font-bold text-gray-900 mb-2">Page not found</h1>
        <p className="text-gray-600 mb-6 max-w-md mx-auto">
          This address does not match a page on the site. Try one of these destinations instead.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Link to="/" className={`${linkBase} bg-primary text-white hover:bg-primary-dark`}>
            Home
          </Link>
          <Link
            to="/resources"
            className={`${linkBase} border-2 border-primary text-primary hover:bg-primary hover:text-white`}
          >
            Resources
          </Link>
          <Link
            to="/programs"
            className={`${linkBase} border-2 border-primary text-primary hover:bg-primary hover:text-white`}
          >
            Programs and Hubs
          </Link>
        </div>
      </div>
    </div>
  );
}
